module.exports = __webpack_public_path__ + "static/media/KN.dfe7fd18.svg";